import React, { useState } from 'react';

import ColorButton from '../../../shared/ColorButton';

const VALUES = ['GTIN', 'REF', 'LOT', 'EXP'];

const NewUsageItem = (props) => {
  const { onSubmit } = props;

  const [data, setData] = useState({
    GTIN: '',
    REF: '',
    LOT: '',
    EXP: '',
    quantity: '1',
  });

  const onSaveClick = () => {
    onSubmit({
      gtin: data.GTIN || '',
      ref: data.REF || '',
      lot: data.LOT || '',
      exp: data.EXP || '',
      quantity: data.quantity || '',
    });
    setData({
      GTIN: '',
      REF: '',
      LOT: '',
      EXP: '',
      quantity: '',
    });
  };

  return (
    <div className=''>
      <div className='p-r-md'>
        {VALUES?.map((label) => (
          <div className='d-flex m-b-md' style={{ alignItems: 'flex-start' }}>
            <div className='font-bold' style={{ minWidth: 60 }}>
              {label}
            </div>
            <div style={{ wordBreak: 'break-word', width: '100%' }}>
              <input
                className='minimized-input'
                type='text'
                value={data[label]}
                onChange={(e) => setData({ ...data, [label]: e.target?.value })}
              />
            </div>
          </div>
        ))}
        <div className='d-flex flex-start' style={{ alignItems: 'flex-start' }}>
          <div className='font-bold' style={{ minWidth: 60 }}>QTY</div>
          <div style={{ wordBreak: 'break-word', width: '100%' }}>
            <input
              className='minimized-input'
              type='number'
              value={data.quantity}
              onChange={(e) => setData({ ...data, quantity: e.target?.value })}
            />
          </div>
        </div>
      </div>
      <div className='d-flex direction-column space-between align-end height-100 m-t-lg'>
        <div className='pointer'>
          <ColorButton
            onClick={onSaveClick}
            color='blue'
            disabled={!data.quantity || (!data.REF && !data.LOT && !data.GTIN)}
            text='Save'
            height={30}
          />
        </div>
      </div>
    </div>
  );
};

export default NewUsageItem;
